import React, { FC } from 'react';
import GroupCondition from '.';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAppSelector } from '../../hooks/reduxHooks';
import { useViewModeReadOnly } from '../../context/ViewMode/viewModeHooks';

export interface GroupConditionListProps {}

const GroupConditionList: FC<GroupConditionListProps> = () => {
    const groupConditions = useAppSelector(({ groupConditions }) => groupConditions.groupConditions);
    const isReadOnly = useViewModeReadOnly();

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            {groupConditions.map((groupCondition, index) => (
                <GroupCondition
                    key={index}
                    groupIndex={index}
                    defaultExpanded={true}
                    showDelete={!isReadOnly}
                />
            ))}
        </LocalizationProvider>
    );
};

export default GroupConditionList;